import { ComponentProps, FC } from 'react';
import { RegisterOptions } from 'react-hook-form';
import { InputText } from './InputText';
import { INPUT_INVALID_FORMAT_MESSAGE, ZIPCODE_MAX_LENGTH, ZIPCODE_MIN_LENGTH } from '../../../constants/form';

const ZIPCODE_PATTERN: RegExp = /^[a-zA-Z0-9]+$/;

export const InputZipcode: FC<ComponentProps<typeof InputText>> = (props) => {
  const validationOptions = getValidationOptions();

  return <InputText {...props} registerOptions={validationOptions} />;
};

InputZipcode.defaultProps = {
  minLength: ZIPCODE_MIN_LENGTH,
  maxLength: ZIPCODE_MAX_LENGTH,
};

function getValidationOptions(): RegisterOptions {
  const registerOptions: RegisterOptions = {
    pattern: {
      value: ZIPCODE_PATTERN,
      message: INPUT_INVALID_FORMAT_MESSAGE,
    },
  };

  return registerOptions;
}
